"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const fa_1 = require("react-icons/fa");
const AssignmentsContext_1 = require("../../assignment/AssignmentsContext");
const ChartContext_1 = require("../../context/ChartContext");
const DispatchContext_1 = require("../../context/DispatchContext");
const ActiveButton_1 = __importDefault(require("../../elements/ActiveButton"));
const ToolTip_1 = __importDefault(require("../../elements/ToolTip/ToolTip"));
const Modal_1 = require("../../elements/popup/Modal");
const useSpectrum_1 = __importDefault(require("../../hooks/useSpectrum"));
const BasicPanelStyle_1 = require("../extra/BasicPanelStyle");
const DefaultPanelHeader_1 = __importStar(require("../header/DefaultPanelHeader"));
const PreferencesHeader_1 = __importDefault(require("../header/PreferencesHeader"));
const ZonesPreferences_1 = __importDefault(require("./ZonesPreferences"));
const ZonesTable_1 = __importDefault(require("./ZonesTable"));
const useActiveSpectrumZonesViewState_1 = require("../../hooks/useActiveSpectrumZonesViewState");
const style = (0, react_1.css) `
  .remove-assignments-btn {
    border-radius: 5px;
    margin-top: 3px;
    margin-left: 2px;
    border: none;
    height: 16px;
    width: 18px;
    font-size: 12px;
    padding: 0;
    background-color: transparent;
  }

  .toggle {
    width: 22px;
    height: 22px;
    margin-left: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
function ZonesPanelInner({ zones, activeTab, xDomain, yDomain, info, showZones, showSignals, showPeaks, }) {
    const [filterIsActive, setFilterIsActive] = (0, react_2.useState)(false);
    const assignmentData = (0, AssignmentsContext_1.useAssignmentData)();
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const modal = (0, Modal_1.useModal)();
    const [isFlipped, setFlipStatus] = (0, react_2.useState)(false);
    const settingRef = (0, react_2.useRef)();
    const tableData = (0, react_2.useMemo)(() => {
        const isInView = (xFrom, xTo, yFrom, yTo) => {
            const factor = 10000;
            xFrom = xFrom * factor;
            xTo = xTo * factor;
            yFrom = yFrom * factor;
            yTo = yTo * factor;
            return (((xTo >= xDomain[0] * factor && xFrom <= xDomain[1] * factor) ||
                (xFrom <= xDomain[0] * factor && xTo >= xDomain[1] * factor)) &&
                ((yTo >= yDomain[0] * factor && yFrom <= yDomain[1] * factor) ||
                    (yFrom <= yDomain[0] * factor && yTo >= yDomain[1] * factor)));
        };
        const getFilteredZones = (zones) => {
            return zones.filter((zone) => {
                return isInView(zone.x.from, zone.x.to, zone.y.from, zone.y.to);
            });
        };
        if (zones.values) {
            const _zones = filterIsActive
                ? getFilteredZones(zones.values)
                : zones.values;
            return _zones.map((zone) => {
                return {
                    ...zone,
                    tableMetaInfo: {
                        isConstantlyHighlighted: isInView(zone.x.from, zone.x.to, zone.y.from, zone.y.to),
                    },
                };
            });
        }
    }, [zones, filterIsActive, xDomain, yDomain]);
    const handleOnFilter = (0, react_2.useCallback)(() => {
        setFilterIsActive(!filterIsActive);
    }, [filterIsActive]);
    const unlinkZoneHandler = (0, react_2.useCallback)((zoneData, isOnZoneLevel = undefined, signalIndex = -1, axis = undefined) => {
        dispatch({
            type: 'UNLINK_ZONE',
            payload: {
                zone: zoneData,
                assignmentData,
                isOnZoneLevel,
                signalIndex,
                axis,
            },
        });
    }, [assignmentData, dispatch]);
    const removeAssignments = (0, react_2.useCallback)(() => {
        unlinkZoneHandler();
    }, [unlinkZoneHandler]);
    const handleOnRemoveAssignments = (0, react_2.useCallback)(() => {
        modal.showConfirmDialog({
            message: 'All assignments will be removed. Are you sure?',
            buttons: [{ text: 'Yes', handler: removeAssignments }, { text: 'No' }],
        });
    }, [removeAssignments, modal]);
    const handleDeleteAll = (0, react_2.useCallback)(() => {
        modal.showConfirmDialog({
            message: 'All zones will be deleted. Are You sure?',
            buttons: [
                {
                    text: 'Yes',
                    handler: () => {
                        dispatch({ type: 'DELETE_2D_ZONE', payload: { assignmentData } });
                    },
                },
                { text: 'No' },
            ],
        });
    }, [assignmentData, dispatch, modal]);
    const settingsPanelHandler = (0, react_2.useCallback)(() => {
        setFlipStatus(!isFlipped);
    }, [isFlipped]);
    const saveSettingHandler = (0, react_2.useCallback)(() => {
        settingRef.current.saveSetting();
        setFlipStatus(false);
    }, []);
    const handleSetShowZones = () => {
        dispatch({
            type: 'TOGGLE_ZONES_VIEW_PROPERTY',
            payload: { key: 'showZones' },
        });
    };
    const handleSetShowSignals = () => {
        dispatch({
            type: 'TOGGLE_ZONES_VIEW_PROPERTY',
            payload: { key: 'showSignals' },
        });
    };
    const handleSetShowPeaks = () => {
        dispatch({
            type: 'TOGGLE_ZONES_VIEW_PROPERTY',
            payload: { key: 'showPeaks' },
        });
    };
    const counter = zones?.values?.length || 0;
    return ((0, jsx_runtime_1.jsxs)("div", { css: [
            BasicPanelStyle_1.tablePanelStyle,
            style,
            isFlipped &&
                (0, react_1.css) `
            th {
              position: relative;
            }
          `,
        ], children: [!isFlipped && ((0, jsx_runtime_1.jsxs)(DefaultPanelHeader_1.default, { counter: counter, counterLabel: (0, DefaultPanelHeader_1.createFilterLabel)(counter, filterIsActive && tableData?.length), onDelete: handleDeleteAll, deleteToolTip: "Delete All Zones", onFilter: handleOnFilter, filterToolTip: filterIsActive ? 'Show all zones' : 'Hide zones out of view', showSettingButton: true, onSettingClick: settingsPanelHandler, children: [(0, jsx_runtime_1.jsx)(ToolTip_1.default, { title: `Remove all assignments`, popupPlacement: "right", children: (0, jsx_runtime_1.jsx)("button", { className: "remove-assignments-btn", type: "button", onClick: handleOnRemoveAssignments, disabled: !zones.values || zones.values.length === 0, children: (0, jsx_runtime_1.jsx)(fa_1.FaUnlink, {}) }) }), (0, jsx_runtime_1.jsx)(ActiveButton_1.default, { popupTitle: "Show/Hide zones", popupPlacement: "right", value: showZones, onClick: handleSetShowZones, children: (0, jsx_runtime_1.jsx)("span", { style: { fontSize: '12px', pointerEvents: 'none' }, children: "z" }) }), (0, jsx_runtime_1.jsx)(ActiveButton_1.default, { popupTitle: "Show/Hide signals", popupPlacement: "right", value: showSignals, onClick: handleSetShowSignals, children: (0, jsx_runtime_1.jsx)("span", { style: { fontSize: '12px', pointerEvents: 'none' }, children: "s" }) }), (0, jsx_runtime_1.jsx)(ActiveButton_1.default, { popupTitle: "Show/Hide peaks", popupPlacement: "right", value: showPeaks, onClick: handleSetShowPeaks, children: (0, jsx_runtime_1.jsx)("span", { style: { fontSize: '12px', pointerEvents: 'none' }, children: "p" }) })] })), isFlipped && ((0, jsx_runtime_1.jsx)(PreferencesHeader_1.default, { onSave: saveSettingHandler, onClose: settingsPanelHandler })), (0, jsx_runtime_1.jsx)("div", { className: "inner-container", children: !isFlipped ? ((0, jsx_runtime_1.jsx)("div", { className: "table-container", children: (0, jsx_runtime_1.jsx)(ZonesTable_1.default, { tableData: tableData, onUnlink: unlinkZoneHandler, nucleus: activeTab, info: info }) })) : ((0, jsx_runtime_1.jsx)(ZonesPreferences_1.default, { ref: settingRef })) })] }));
}
const MemoizedZonesPanel = (0, react_2.memo)(ZonesPanelInner);
const emptyData = { zones: {}, info: {} };
function ZonesPanel() {
    const { displayerKey, xDomain, yDomain, view: { spectra: { activeTab }, }, } = (0, ChartContext_1.useChartData)();
    const { zones, info } = (0, useSpectrum_1.default)(emptyData);
    const zoneProps = (0, useActiveSpectrumZonesViewState_1.useActiveSpectrumZonesViewState)();
    return ((0, jsx_runtime_1.jsx)(MemoizedZonesPanel, { xDomain,
        yDomain,
        activeTab,
        displayerKey,
        zones,
        info,
        ...zoneProps }));
}
exports.default = ZonesPanel;
